<template>
  <v-dialog v-model="dialog" persistent max-width="500px" @keydown.esc="close()">
    <v-card>
      <v-card-text class="pt-2">
        <v-autocomplete :items="select" label="Agente" item-text="Nome" item-value="Nome" v-model="agente" return-object
          :loading="attesa" ref="inputSel" clearable hide-details :menu-props="{ bottom: true, offsetY: true }" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click.native="close()">Annulla</v-btn>
        <v-btn color="primary" text @click.native="conferma()" :disabled="attesa">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get_listaAgenti } from "@/api/api.agenti.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
  },

  data: () => ({
    select: [],
    agente: { CodAgente: 0, Nome: "" },
    attesa: false,
  }),

  methods: {
    caricaDati() {
      // Reset
      this.select = [];

      this.attesa = true;

      get_listaAgenti()
        .then((res) => {
          this.select = res.data;

          // Inserisco "vuoto" (nella prima posizione)
          this.select.unshift({ CodAgente: 0, Nome: "" });

          // Imposto quello attualmente selezionato
          this.agente = {
            CodAgente: this.$store.state.user.userSwitch.Codice,
            Nome: this.$store.state.user.userSwitch.Nome,
          };

          // Focus su combo
          this.$nextTick(() => this.$refs.inputSel.focus());

          this.attesa = false;
        })
        .catch((err) => {
          console.log("listaAgenti.vue " + err);

          this.attesa = false;
        });
    },

    conferma() {
      let par = {};

      // Controllo vuoto
      if (this.agente && this.agente.CodAgente) {
        par = {
          Codice: this.agente.CodAgente,
          Nome: this.agente.Nome,
          Tipo: "Agente",
        };
      }

      this.$store.commit("user/SET_USERSWITCH", par);

      this.close();
    },

    close() {
      this.$store.commit("app/SET_DIALOG", "");
    },
  },

  watch: {
    dialog(val) {
      if (!val) return;

      this.caricaDati();
    },
  },
};
</script>
